__webpack_require__.p = "/monaco-sql-languages/";